import { makeUrl } from '../../utils/base-url';
import { stringifyUrlParams } from '../../utils/url-params';
import { HttpServiceConfigurator } from './http-service-configurator';
import { createHttpService } from './http-service-factory';
import { AuthHttpServiceConfigurator } from './auth-http-service-configurator';
import { NotificationHttpServiceConfigurator } from './notification-http-service-configurator';
import { RefreshableHttpServiceConfigurator } from './refreshable-http-service-configurator';

const httpService = createHttpService(new RefreshableHttpServiceConfigurator());

export const authHttpService = createHttpService(
  new AuthHttpServiceConfigurator()
);

export const notificationHttpService = createHttpService(
  new NotificationHttpServiceConfigurator()
);

export const generateDownloadLink = (url: string) => {
  const headers = HttpServiceConfigurator.getHeaders();
  return `${makeUrl(url)}?${stringifyUrlParams(headers)}`;
};

export default httpService;
